import styled from 'styled-components';
import { withStyles } from '@material-ui/core';
import THEME from '../../../../../constants/theme';

export const Address = styled.a`
  color: ${THEME.grey};
  cursor: pointer;
  display: inline;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
  text-decoration: underline;
`;

export const DeliveryContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const PickupContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.8;
`;

export const Title = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  margin: 0 25px 0 0;
  min-width: 80px;
`;

export const Warning = styled.span`
  color: ${THEME.warning};
  font-size: 14px;
  font-weight: 500;
`;

export const Info = styled.span`
  color: ${THEME.grey};
  font-size: 14px;
  font-style: italic;
  font-weight: 500;
`;

export const withPickupDeliveryStyles = withStyles(theme => ({
  root: {
    borderBottom       : `1px solid ${THEME.lightGrey}`,
    display            : 'grid',
    padding            : theme.spacing(5),
    gridGap            : theme.spacing(4),
    gridTemplateColumns: '1fr',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(auto-fill, minmax(min(270px, 100%), 1fr))',
    },
    '& > span': {
      width              : '100%',
      display            : 'grid',
      gridTemplateColumns: '90px 1fr',
    },
  },
}));
